import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PopoverTrigger = PopoverPrimitive.Trigger;
